__webpack_require__.p = "https://cdn.yaoxincs.com/competition_community_frontend/1.0.0/";